import { FC, Fragment } from 'react';
import NGSkeleton from 'src/styles/theme/components/NGSkeleton';
import { ESize, ETextColor } from 'src/styles/theme/utils/enums';
import { EFontFamily, EFontStyle, EFontWeight, ETextAlign, ETextType } from './NGText.enum';
import { StyledFirstLetter, StyledTextParagraph, StyledTextSpan } from './NGText.styles';
import { INGText } from './NGText.type';

const NGText: FC<INGText> = ({
	children,
	singleLine = false,
	inheritStyle = true,
	isHidden = false,
	type = ETextType.p,
	textColor = ETextColor.white,
	size = ESize.m,
	textAlign = ETextAlign.left,
	textTransform,
	firstLetterFactor,
	fontWeight = EFontWeight.regular,
	fontFamily = EFontFamily.lato,
	fontStyle = EFontStyle.normal,
	textDecoration,
	shadowColor,
	isLoading = false,
	loaderLineCount = 1,
	skWidth = '80%',
	skHeight = ESize.xs,
	...otherProps
}) => {
	const commonProps = {
		singleLine,
		fontWeight,
		isHidden,
		textAlign,
		textTransform,
		firstLetterFactor,
		textColor,
		textDecoration,
		size,
		fontFamily,
		fontStyle,
		shadowColor
	};

	if (isLoading && !isHidden) {
		return (
			<>
				{Array.from({ length: loaderLineCount }).map((_, i) => (
					<NGSkeleton
						key={'text-sk-' + i}
						as='span'
						width={skWidth}
						height={skHeight}
						marginTop={i > 0 ? ESize['5xs'] : undefined}
						{...otherProps}
					/>
				))}
			</>
		);
	}

	switch (type) {
		case ETextType.p:
			return (
				<StyledTextParagraph {...commonProps} {...otherProps}>
					{children}
				</StyledTextParagraph>
			);
		case ETextType.span:
			return (
				<StyledTextSpan {...commonProps} inheritStyle={inheritStyle} {...otherProps}>
					{children && typeof children === 'string' && firstLetterFactor ? (
						<>
							{/* // to fix the first letter bug on firefox (that adds extra space at the end)
									: more info: https://bugzilla.mozilla.org/show_bug.cgi?id=1279244
							*/}
							{children.split(' ').map((word, i) => (
								<Fragment key={word + '-' + i}>
									{i === 0 ? (
										<>
											<StyledFirstLetter inheritStyle={inheritStyle} {...commonProps}>
												{children[0]}
											</StyledFirstLetter>
											{word.split(children[0])}{' '}
										</>
									) : (
										`${word} `
									)}
								</Fragment>
							))}
						</>
					) : (
						children
					)}
				</StyledTextSpan>
			);
		default:
			return null;
	}
};

export { NGText };
